export enum FlexDirection {
  ROW = 'row',
  COLUMN = 'column',
  ROW_REVERSE = 'row-reverse',
}

export enum AlignItems {
  CENTER = 'center',
  START = 'flex-start',
  END = 'flex-end',
  STRETCH = 'stretch',
  BASELINE = 'baseline',
}

export enum JustifyContent {
  CENTER = 'center',
  START = 'flex-start',
  END = 'flex-end',
  SPACE_BETWEEN = 'space-between',
  SPACE_AROUND = 'space-around',
  SPACE_EVENLY = 'space-evenly',
  STRETCH = 'stretch',
}
